import { useContext } from 'react';
import type { HostWorkspace } from '@/api/hostWorkspace/hostWorkspaceApi.types';
import { HostWorkspaceContext } from '@/providers/hostWorkspaceContext';

export function useHostWorkspace(): HostWorkspace | null {
  return useContext(HostWorkspaceContext).hostWorkspace;
}
